<div class="sidebar-tab-icon">
    <adapt-icon [icon]="iconClassValue"></adapt-icon>
    @if (iconText) {
        <div class="icon-text">{{ iconText }}</div>
    }
</div>
